export default __webpack_public_path__ + "static/media/com-1.5ed9251b.jpg";